import API from '@/views/Fdc/Apis/'
import _ from 'lodash'
// import { mapGetters } from 'vuex'

export default {
  name: 'TraceCollectionPlan',
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  watch: {
  },
  beforeMount () {
    this.initDCPlanGridColumns()
    this.initTracePlanGridColumns()
    this.initEqpParamGrid()
    this.initTraceVidGrid()
  },
  mounted () {
    /**
     * Data Collection Plan에서 화면 연동 시 데이터 처리
     */
    let params = this.$route.query

    if (params.fab && params.eqpId && params.planName) {
      this.nodeObj = this.$route.query
      // this.selectedTreeNode.detail = params
      this.searchTreeNode.detail = params
      this.searchToLink(params.fab, params.eqpId, params.planName, params.trid)
    }
  },
  methods: {
    /**
     * Data Collection Plan Grid 초기화
     */
    initDCPlanGridColumns () {
      // this.dcPlanGrid = grid
      // grid.itemsSourceChanged.addHandler((s, e) => {
      //   if (s.rows.length > 0) {
      //     this.dcSelRowIdx = 0
      //     this.searchTracePlanList(this.searchTreeNode.detail.fab, this.searchTreeNode.detail.eqpId, s.selectedItems[0].planName)
      //     this.searchEqpParamList(this.searchTreeNode.detail.fab, this.searchTreeNode.detail.eqpId)
      //   }
      // })
      this.dcColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.PLAN_NAME'), field: 'planName', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.IDLE_APPLY'), field: 'idleApplyYn', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_TIMEOUT'), field: 'lotTimeout', width: 120, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_TIMEOUT'), field: 'substTimeout', width: 130, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRACE_TIMEOUT'), field: 'traceTimeout', width: 130, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.TARGET'), field: 'targetId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SOURCE'), field: 'sourceId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TARGET_URL'), field: 'targetUrl', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_CMD'), field: 'eventCmd', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRACE_CMD'), field: 'traceCmd', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.REQUEST_URL'), field: 'requestUrl', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.REPLY_URL'), field: 'replyUrl', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 180, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]
    },
    /**
     * Trace Collection Plan Grid 초기화
     * @param {*} grid wijmo grid
     * Cell Edit End, Cell Edit Ending event 설정
     */
    initTracePlanGridColumns (grid) {
      // this.tracePlanGrid = grid
      // grid.cellEditEnding.addHandler((s, e) => {
      //   this.keyValidationCheck(s, e)
      //   this.cellEditEnded(s, e)
      // })
      // grid.cellEditEnded.addHandler((s, e) => {
      //   this.keyValidationCheck(s, e)
      //   this.cellEditEnded(s, e)
      // })

      // var columnsLength = grid.columns.length
      // for (var i = 0; i < columnsLength; i++) {
      //   var column = grid.columns[i]
      //   if (column.binding === 'planName') column.maxLength = 32
      //   else if (column.binding === 'trid') column.maxLength = 8
      //   else if (column.binding === 'mainYn') column.maxLength = 1
      //   else if (column.binding === 'groupSize') column.maxLength = 11
      //   else if (column.binding === 'runInterval') column.maxLength = 11
      //   else if (column.binding === 'idleInterval') column.maxLength = 11
      // }

      this.tracePlanColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', modifiable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', modifiable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PLAN_NAME'), field: 'planName', width: 150, modifiable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRID'), field: 'trid', width: 120, required: true, modifiable: true, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRID_MAIN'), field: 'mainYn', width: 100, required: true, modifiable: true, dataMap: ['Y', 'N'] },
        { headerName: this.$t('fdc.COMMON.COLUMN.GROUP_SIZE'), field: 'groupSize', width: 100, required: true, modifiable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.RUN_INTERVAL'), field: 'runInterval', width: 120, required: true, modifiable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.IDLE_INTERVAL'), field: 'idleInterval', width: 130, required: true, modifiable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VID_LIST'), field: 'vidList', width: 500 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 180, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]
    },
    dataPlanGridRowClicked (params) {
      const { fab, eqpId, planName } = params.data
      if (fab && eqpId && planName) {
        this.initTraceData()

        this.searchTracePlanList(fab, eqpId, planName)
        this.searchEqpParamList(fab, eqpId)
      }
    },
    /**
     * Parameter(VID) Grid Column 초기화
     */
    initEqpParamGrid () {
      this.eqpParamColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.VID'), field: 'vid', width: 120, allowMerging: true, checkboxSelection: true, headerCheckboxSelection: true, sort: 'asc' },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', width: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_DESC'), field: 'paramDesc', width: 200 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', width: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'id', hide: true }
      ]
    },
    /**
     * Selected Vid List Grid Column 초기화
     */
    initTraceVidGrid () {
      this.traceVidColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.VID'), field: 'vid', width: 120, allowMerging: true, checkboxSelection: true, headerCheckboxSelection: true, sort: 'asc' },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', width: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_DESC'), field: 'paramDesc', width: 200 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', width: 160 }
      ]
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Data Collection Plan Grid row select method
     * @param {*} grid wijmo grid
     */
    dcPlanGridSelected (grid) {
      if (grid.selectedItems.length === 1 /* && this.dcSelRowIdx !== event.row */) {
        let node = this.selectedTreeNode
        if (node != null) {
          if (grid.selectedItems[0].planName != null) {
            this.tracePlanRowData = []
            this.tracePlanOrgRowData = []

            this.eqpParamRowData = []
            this.eqpParamOrgRowData = []

            this.traceVidRowData = []
            this.traceVidOrgRowData = []

            this.dcSelRowIdx = -1

            this.searchTracePlanList(node.detail.fab, node.detail.eqpId, grid.selectedItems[0].planName)
            this.searchEqpParamList(node.detail.fab, node.detail.eqpId)
          }
        }
        // 동일한 row에서 다른 컬럼 클릭시에도 이벤트가 발생하므로 아래와 같이 처리해둠. sort?? ㅡㅡ;
        // this.dcSelRowIdx = event.row
        // this.traceSelRowIdx = -1
      }
    },
    /**
     * Trace Collection Plan Grid row select method
     * @param {*} grid wijmo grid
     */
    tracePlanGridSelectionChanged (checkedRows) {
      if (checkedRows.length === 1) {
        let node = this.selectedTreeNode
        if (checkedRows[0].planName !== null) {
          this.searchSubPlanList(node.detail.fab, node.detail.eqpId, checkedRows[0].planName, checkedRows[0].trid)
        }
      } else if (checkedRows.length === 0) {
        this.eqpParamRowData = []
        this.traceVidRowData = []

        this.detailTrid = null
        this.detailTridMain = null
        this.detailRunInterval = null
        this.detailIdleInterval = null
      }
    },
    _tracePlanGridSelected (grid) {
      if (grid.selectedItems.length === 1/* && this.traceSelRowIdx !== event.row */) {
        let node = this.selectedTreeNode
        if (node != null) {
          if (grid.selectedItems[0].planName != null) {
            this.searchSubPlanList(node.detail.fab, node.detail.eqpId, grid.selectedItems[0].planName, grid.selectedItems[0].trid)
          }
        }
        // 동일한 row에서 다른 컬럼 클릭시에도 이벤트가 발생하므로 아래와 같이 처리해둠. sort?? ㅡㅡ;
        // this.dcSelRowIdx = event.row
      }
    },
    /**
     * Trace Collection Plan Grid cell edit 종료 시 수행하는 method
     * @param {*} grid wijmo grid
     * @param {*} event edit event
     */
    cellEditEnded (grid, event) {
      let col = grid.columns[event.col]
      // let rowData = grid.rows[event.row]._data
      let rowStatus = grid.rows[event.row]._data._status

      // modified and added row 시 자동 check (checkbox column 제외)
      if (col.binding !== '_status.checked') {
        if (rowStatus.modified || rowStatus.added) {
          rowStatus.checked = true
        }
        // else {
        //   rowStatus.checked = false
        // }
      }

      // if (rowData.eqpId && col.binding === 'mainYn' && rowData.mainYn === 'Y' && rowStatus.modified) {
      //   let allRows = this.$refs.tracePlanGrid.grid.rows
      //   for (var i = 0; i < allRows.length; i++) {
      //     let dataItem = allRows[i].dataItem
      //     if (event.row !== i) {
      //       dataItem.mainYn = 'N'
      //     }
      //   }
      // }
    },
    /**
     * Key Validation 체크
     * @param {*} sender wijmo grid
     * @param {*} e event
     */
    keyValidationCheck (sender, e) {
      var flex = sender
      if (flex.activeEditor == null) {
        return
      }
      var item = flex.collectionView.currentEditItem
      let col = sender.columns[e.col]

      if (col.binding === 'trid') {
        let trid = flex.activeEditor.value
        flex.rows.some(row => {
          if (!_.isEqual(item, row.dataItem) && trid === row.dataItem.trid) {
            e.cancel = true
            this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
          }
        })
      }
    },
    /**
     * Data 초기화
     */
    initRowDataAll () {
      this.dcRowData = []

      this.tracePlanRowData = []
      this.tracePlanOrgRowData = []

      this.eqpParamRowData = []
      this.eqpParamOrgRowData = []

      this.traceVidRowData = []
      this.traceVidOrgRowData = []

      this.dcSelRowIdx = -1

      this.detailTrid = null
      this.detailTridMain = null
      this.detailRunInterval = null
      this.detailIdleInterval = null

      this.enableEditTracePlan = false
    },
    initTraceData () {
      this.tracePlanRowData = []
      this.tracePlanOrgRowData = []

      this.eqpParamRowData = []
      this.eqpParamOrgRowData = []

      this.traceVidRowData = []
      this.traceVidOrgRowData = []

      this.dcSelRowIdx = -1

      this.detailTrid = null
      this.detailTridMain = null
      this.detailRunInterval = null
      this.detailIdleInterval = null

      this.enableEditTracePlan = false
    },
    /**
     * Data 검색 (Data Collection Plan)
     */
    searchProcess () {
      this.initRowDataAll()

      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.eqpId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.searchDataCollectionPlanList(node.detail.fab, node.detail.eqpId)
    },
    /**
     * Data Collection Plan 조회 (Data Collection Plan에서 연동 시)
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} planName  Plan Name
     */
    async searchToLink (fab, eqpId, planName) {
      this.initRowDataAll()

      let payload = {
        fab: fab,
        eqpId: eqpId
      }

      API.Collection.getSyncCollectionPlans(payload)
        .then(response => {
          this.dcRowData = response.data

          const findItem = this.dcRowData.find(function (item) {
            return (_.isEqual(item.planName, planName))
          })
          if (findItem !== null && findItem !== undefined) {
            setTimeout(() => {
              const rowIndex = this.dcPlanGrid.collectionView.items.indexOf(findItem)
              this.dcPlanGrid.select(rowIndex, 1)
              this.dcPlanGrid.focus()
            }, 100)
          }
        })
    },
    /**
     * Data Collection Plan 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     */
    async searchDataCollectionPlanList (fab, eqpId) {
      let payload = {
        fab: fab,
        eqpId: eqpId
      }
      let data = await API.Collection.getCollectionPlans(payload)
      this.dcRowData = data
    },
    /**
     * Trace Collection Plan 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} planName Plan Name
     */
    async searchTracePlanList (fab, eqpId, planName) {
      let payload = {
        fab: fab,
        eqpId: eqpId,
        planName: planName
      }
      let data = await API.Collection.getTracePlans(payload)
      this.tracePlanRowData = _.clone(data)
      this.tracePlanOrgRowData = _.clone(data)
    },
    /**
     * Parameter 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     */
    async searchEqpParamList (fab, eqpId) {
      let payload = {
        fab: fab,
        eqpId: eqpId
      }

      let eqpParamData = await API.FdcCollectionPlan.getEqpParamList(payload)
      // this.eqpParamRowData = _.clone(eqpParamData)
      this.eqpParamOrgRowData = _.clone(eqpParamData.map((item, index) => {
        return { ...item, id: index }
      }))
    },
    /**
     * Trace Collection Plan 상세 및 VID list 정보 설정
     */
    async searchSubPlanList () {
      this.traceVidRowData = []
      this.traceVidOrgRowData = []

      this.eqpParamRowData = []
      // [2020.07 brique] 기존에 있는 vid list 제거 logic 추가 - start
      let eqpParamList = _.clone(this.eqpParamOrgRowData)
      let selectedVidList = ''
      for (let i in this.tracePlanRowData) {
        selectedVidList = selectedVidList + this.tracePlanRowData[i].vidList + ','
      }
      let vidList = []
      for (let j in eqpParamList) {
        if (!selectedVidList.includes(eqpParamList[j].vid)) {
          vidList.push(eqpParamList[j])
        }
      }

      this.eqpParamRowData = vidList
      // [2020.06 brique] 기존에 있는 vid list 제거 logic 추가 - end

      // this.eqpParamRowData = _.clone(this.eqpParamOrgRowData)

      let tracePlanInfo = this.$refs.tracePlanGrid.getCheckedRows()[0]
      this.traceVidRowOrgData = _.clone(tracePlanInfo)

      if (tracePlanInfo !== null) {
        if (_.isEmpty(tracePlanInfo.vidList) === false || tracePlanInfo.vidList !== '') {
          let vidList = tracePlanInfo.vidList.split(',')
          vidList.forEach((vid, index) => {
            let data = this.eqpParamOrgRowData.filter(row => row.vid === vid)
            // let data = this.eqpParamRowData.filter(row => row.vid === vid)
            for (let param of data) {
              let addItem =
              {
                vid: param.vid,
                paramName: param.paramName,
                paramDesc: param.paramDesc,
                aliasName: param.aliasName,
                id: index
              }
              this.traceVidRowData.push(addItem)
            }
          })
          this.syncGridViews()
        }
        this.detailTrid = tracePlanInfo.trid
        this.detailTridMain = tracePlanInfo.mainYn
        this.detailRunInterval = tracePlanInfo.runInterval
        this.detailIdleInterval = tracePlanInfo.idleInterval

        this.enableEditTracePlan = true
      } else {
        this.enableEditTracePlan = false
      }
    },
    async _searchSubPlanList () {
      this.traceVidRowData = []
      this.traceVidOrgRowData = []

      this.eqpParamRowData = []
      // [2020.07 brique] 기존에 있는 vid list 제거 logic 추가 - start
      let eqpParamList = _.clone(this.eqpParamOrgRowData)
      let allVidList = ''
      for (let i in this.tracePlanRowData) {
        allVidList = allVidList + this.tracePlanRowData[i].vidList + ','
      }
      let possibleVidList = []
      for (let j in eqpParamList) {
        if (!allVidList.includes(eqpParamList[j].vid)) {
          possibleVidList.push(eqpParamList[j])
        }
      }

      this.eqpParamRowData = possibleVidList
      // [2020.06 brique] 기존에 있는 vid list 제거 logic 추가 - end

      // this.eqpParamRowData = _.clone(this.eqpParamOrgRowData)

      let tracePlanInfo = this.tracePlanGrid.selectedItems[0]
      this.traceVidRowOrgData = _.clone(tracePlanInfo)

      if (tracePlanInfo !== null) {
        if (_.isEmpty(tracePlanInfo.vidList) === false || tracePlanInfo.vidList !== '') {
          let vidList = tracePlanInfo.vidList.split(',')
          vidList.forEach(vid => {
            let data = this.eqpParamOrgRowData.filter(row => row.vid === vid)
            // let data = this.eqpParamRowData.filter(row => row.vid === vid)
            for (let param of data) {
              let addItem =
              {
                vid: param.vid,
                paramName: param.paramName,
                paramDesc: param.paramDesc,
                aliasName: param.aliasName
              }
              this.traceVidRowData.push(addItem)
            }
          })
          this.syncGridViews()
        }
        this.detailTrid = tracePlanInfo.trid
        this.detailTridMain = tracePlanInfo.mainYn
        this.detailRunInterval = tracePlanInfo.runInterval
        this.detailIdleInterval = tracePlanInfo.idleInterval

        this.enableEditTracePlan = true
      } else {
        this.enableEditTracePlan = false
      }
    },
    /**
     * VID 목록 동기화
     * Trace Collection Plan에 저장된 VID와 아닌 VID를 각 해당 목록으로 표시합니다.
     */
    syncGridViews () {
      if (this.traceVidRowData.length > 0) {
        this.traceVidRowData.forEach(row => {
          this.delEqpParamVid(row.vid, row.paramName)

          // this.eqpParamGrid.collectionView.refresh()
          // this.traceVidGrid.collectionView.refresh()
        })
      }
    },
    onRowDataChanged () {
      if (this.lastestSelectedData) {
        let tempData = this.lastestSelectedData
        const model = this.$refs.tracePlanGrid.gridApi.getModel()
        const rowCount = model.getRowCount()
        for (let i = 0; i < rowCount; i++) {
          const node = model.getRow(i)
          if (node) {
            let { trid } = node.data
            if (trid === tempData.trid) {
              node.setSelected(true)
              this.lastestSelectedData = null
              break
            }
          }
        }
      }
    },
    /**
     * 정보 재조회
     */
    refreshTracePlanGrid () {
      this.initTraceData()

      if (this.searchTreeNode) {
        let selectEqpVo = this.searchTreeNode.detail
        const checkedRows = this.$refs.dcPlanGrid.getCheckedRows()
        if (checkedRows.length > 0) {
          this.searchTracePlanList(selectEqpVo.fab, selectEqpVo.eqpId, checkedRows[0].planName)
          this.searchEqpParamList(selectEqpVo.fab, selectEqpVo.eqpId)
        }
      }
    },
    _refreshTracePlanGrid () {
      this.tracePlanRowData = []
      this.tracePlanOrgRowData = []

      this.eqpParamRowData = []
      this.eqpParamOrgRowData = []

      this.traceVidRowData = []
      this.traceVidOrgRowData = []

      this.detailTrid = null
      this.detailTridMain = null
      this.detailRunInterval = null
      this.detailIdleInterval = null

      this.enableEditTracePlan = false

      if (this.searchTreeNode &&
        this.dcPlanGrid.selectedItems !== null && this.dcPlanGrid.selectedItems.length > 0) {
        let selectEqpVo = this.searchTreeNode.detail

        // const setCurTrid = this.tracePlanGrid.selectedItems[0].trid
        // console.log('setCurTrid', setCurTrid)

        if (this.dcPlanGrid.selectedItems[0] !== null || this.dcPlanGrid.selectedItems[0] !== undefined) {
          this.searchTracePlanList(selectEqpVo.fab, selectEqpVo.eqpId, this.dcPlanGrid.selectedItems[0].planName)
          this.searchEqpParamList(selectEqpVo.fab, selectEqpVo.eqpId)

          /* const findItem = this.tracePlanRowData.find(function (item) {
            return (_.isEqual(item.planName, setCurTrid))
          })
          if (findItem !== null && findItem !== undefined) {
            setTimeout(() => {
              const rowIndex = this.tracePlanGrid.collectionView.items.indexOf(findItem)
              this.tracePlanGrid.select(rowIndex, 1)
              this.tracePlanGrid.focus()
            }, 100)
          } */
        }
      }
    },
    /**
     * Trace Collection Plan Grid에 check된 row count 확인
     * @returns {*} check된 row가 있는지 여부
     */
    hasCheckedTracePlanRows () {
      if (!this.$refs.tracePlanGrid) {
        return 0
      }
      return this.$refs.tracePlanGrid.checkedRowCount > 0
    },
    /**
     * Parameter Grid에 check된 row count 확인
     * @returns {*} check된 row가 있는지 여부
     */
    hasCheckedEqpParamRows () {
      if (!this.$refs.eqpParamGrid) {
        return 0
      }
      return this.$refs.eqpParamGrid.checkedRowCount > 0
    },
    /**
     * Selected Vid Grid에 check된 row count 확인
     * @returns {*} check된 row가 있는지 여부
     */
    hasCheckedTraceVidRows () {
      if (!this.$refs.traceVidGrid) {
        return 0
      }
      return this.$refs.traceVidGrid.checkedRowCount > 0
    },
    /**
     * Refresh/Add Button 활성화 여부 결정
     * @returns {Boolean} Refresh/Add Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Refresh/Add Button 활성화 여부를 결정합니다.
     */
    existRowsDCPlan () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        if (!this.$refs.dcPlanGrid) {
          return 0
        }
        return this.$refs.dcPlanGrid.checkedRowCount > 0
      }
    },
    _existRowsDCPlan () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (selectEqpVo.fab !== null && selectEqpVo.eqpId !== null && this.dcPlanGrid.selectedItems !== null && this.dcPlanGrid.selectedItems.length > 0) {
          return true
        }
        return false
      }
    },
    // existTraceVid () {
    //   if (!this.existRowsDCPlan()) {
    //     return false
    //   } else {
    //     if ((this.traceVidRowOrgData === null || this.traceVidRowOrgData === undefined) && this.traceVidGrid.collectionView.items.length <= 0) {
    //       return false
    //     }
    //   }
    //   return true
    // },
    /**
     * Trace Collection Plan에 등록된 VID인지 체크
     * @returns {Boolean} VID 존재 여부
     */
    existTraceVidRowData (vid, paramName) {
      if (this.traceVidRowData.length === 0) {
        return false
      }

      let bResult = false

      this.traceVidRowData.some(row => {
        if (_.isEqual(row.vid, vid) && _.isEqual(row.paramName, paramName)) {
          bResult = true
        }
      })
      return bResult
    },
    /**
     * TRID max 값 계산
     * @returns {String} max trid
     */
    getMaxTrid () {
      let trid = 0
      this.$refs.tracePlanGrid.getAllRows().some(row => {
        let currentTrid = parseInt(row.trid)
        if (trid <= currentTrid) {
          trid = currentTrid + 1
        }
      })
      if (_.isEqual(0, trid)) {
        trid = trid + 1
      }
      return trid.toString()
    },
    /**
     * Trace Collection Plan 신규 row 추가
     */
    newRowAddTracePlan () {
      const selectEqpVo = this.searchTreeNode.detail
      if (selectEqpVo) {
        const planName = this.$refs.dcPlanGrid.getCheckedRows()[0].planName
        const trid = this.getMaxTrid()

        // [2020.07 brique] TRID Main 존재 시 N으로 new row 추가 logic 추가
        let mainYnExist = false
        this.$refs.tracePlanGrid.gridApi.forEachNode((node) => {
          if (node.data.mainYn === 'Y') {
            mainYnExist = true
          }
        })

        const tracePlan = {
          fab: selectEqpVo.fab,
          eqpId: selectEqpVo.eqpId,
          planName: planName,
          trid: trid,
          mainYn: mainYnExist ? 'N' : 'Y',
          groupSize: 1,
          runInterval: 1000,
          idleInterval: 10000,
          vidList: ''
        }
        this.$refs.tracePlanGrid.addRowOne(tracePlan)
        this.enableEditTracePlan = true
      }
    },
    _newRowAddTracePlan () {
      let selectEqpVo = this.searchTreeNode.detail
      if ((selectEqpVo !== null && selectEqpVo !== undefined) && (this.dcPlanGrid.selectedItems.length > 0)) {
        let planName = this.dcPlanGrid.selectedItems[0].planName
        let trid = this.getMaxTrid()

        // [2020.07 brique] TRID Main 존재 시 N으로 new row 추가 logic 추가
        let mainYnExist = false
        if (this.$refs.tracePlanGrid.rows.length > 0) {
          for (let i = 0; i < this.$refs.tracePlanGrid.rows.length; i++) {
            if (this.$refs.tracePlanGrid.rows[i].dataItem) {
              if (this.$refs.tracePlanGrid.rows[i].dataItem.mainYn === 'Y') {
                mainYnExist = true
              }
            }
          }
        }

        let arr = [
          {
            fab: selectEqpVo.fab,
            eqpId: selectEqpVo.eqpId,
            planName: planName,
            trid: trid,
            mainYn: mainYnExist ? 'N' : 'Y',
            groupSize: 1,
            runInterval: 1000,
            idleInterval: 10000,
            vidList: ''
          }
        ]
        let status = {
          checked: true,
          modified: false,
          added: true
        }
        this.$refs.tracePlanGrid.addRows(arr, status)
      }
    },
    getRowNodeId (data) {
      return data.id
    },
    /**
     * Selected Vid 추가
     */
    newRowAddVid () {
      let selectEqpVo = this.searchTreeNode.detail
      const planGridCheckedRows = this.$refs.dcPlanGrid.getCheckedRows()
      if (selectEqpVo && planGridCheckedRows.length > 0) {
        let vidListCheckedRows = this.$refs.eqpParamGrid.getCheckedRows()

        if (vidListCheckedRows.length < 1) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
          return
        }

        // TODO :: 같은 vid 모두 check인지 확인
        let allVidCheck = true
        vidListCheckedRows.forEach((data) => {
          this.$refs.eqpParamGrid.gridApi.forEachNode(node => {
            if (node.data.vid === data.vid && node.selected === false) {
              allVidCheck = false
            }
          })
        })

        if (!allVidCheck) {
          this.$dialog.alert(this.$t('fdc.DATA_COLLECTION.MESSAGE.INFORM_NOT_CHECK_VID'))
          return
        }
        const tempVidArr = []
        vidListCheckedRows.some((row, index) => {
          if (this.existTraceVidRowData(row.vid, row.paramName) === false) {
            // 선택된 eqp param grid의 데이터 중에서 DC Trace grid에 없는 것만 추가한다.
            const addItem = {
              vid: row.vid,
              paramName: row.paramName,
              paramDesc: row.paramDesc,
              aliasName: row.aliasName
            }
            tempVidArr.push(addItem)
            this.$refs.traceVidGrid.addRowOne(addItem)
            this.delEqpParamVid(row.vid, row.paramName)
          }
        })
        /**
         * NOTE:
         * Arrow right 버튼이 disabled 속성 업데이트가 안되는 상황발생
         * 데이터를 넘긴후 hasCheckedEqpParamRows 함수가 호출이 안됨
         * 아래와 같은 방법으로 ag-grid도 업데이트 해줌
         */
        this.$refs.eqpParamGrid.onClickRemoveRow()
      }
    },
    _newRowAddVid () {
      let selectEqpVo = this.searchTreeNode.detail
      if ((selectEqpVo !== null && selectEqpVo !== undefined) && (this.dcPlanGrid.selectedItems.length > 0)) {
        let checkedRows = this.$refs.eqpParamGrid.checkedRows

        if (checkedRows < 1) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
          return
        }

        // TODO :: 같은 vid 모두 check인지 확인
        let allVidCheck = true
        this.eqpParamRowData.forEach(row => {
          if (row.vid === checkedRows[0].vid && !row._status.checked) {
            allVidCheck = false
          }
        })

        if (!allVidCheck) {
          this.$dialog.alert(this.$t('fdc.DATA_COLLECTION.MESSAGE.INFORM_NOT_CHECK_VID'))
          return
        }

        checkedRows.some(row => {
          if (this.existTraceVidRowData(row.vid, row.paramName) === false) {
            // 선택된 eqp param grid의 데이터 중에서 DC Trace grid에 없는 것만 추가한다.
            const addItem = [
              {
                vid: row.vid,
                paramName: row.paramName,
                paramDesc: row.paramDesc,
                aliasName: row.aliasName
              }
            ]
            let status = {
              checked: true,
              modified: true,
              added: true
            }
            this.$refs.traceVidGrid.addRows(addItem, status)
            this.delEqpParamVid(row.vid, row.paramName)
          }
        })

        // [2020.05.28 brique] 수정, save process 변경으로 주석 처리 (grid refresh만 처리) - start
        // this.setVidListToTracePlan()
        this.eqpParamGrid.collectionView.refresh()
        this.traceVidGrid.collectionView.refresh()
        // [2020.05.28 brique] 수정, save process 변경으로 주석 처리 (grid refresh만 처리) - end
      }
    },
    /**
     * Selected Vid 삭제
     */
    deleteVid () {
      let selectEqpVo = this.searchTreeNode.detail
      const planGridCheckedRows = this.$refs.dcPlanGrid.getCheckedRows()
      if (selectEqpVo && planGridCheckedRows.length > 0) {
        let selectedVidCheckedRows = this.$refs.traceVidGrid.getCheckedRows()
        if (selectedVidCheckedRows < 1) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
          return
        }

        // TODO :: 같은 vid 모두 check인지 확인
        let allVidCheck = true
        selectedVidCheckedRows.forEach((data) => {
          this.$refs.traceVidGrid.gridApi.forEachNode(node => {
            if (node.data.vid === data.vid && node.selected === false) {
              allVidCheck = false
            }
          })
        })

        if (!allVidCheck) {
          this.$dialog.alert(this.$t('fdc.DATA_COLLECTION.MESSAGE.INFORM_NOT_CHECK_VID'))
          return
        }

        selectedVidCheckedRows.forEach((row) => {
          this.addEqpParamVid(row.vid, row.paramName)
        })
        this.$refs.traceVidGrid.onClickRemoveRow()
        this.syncTracVidGridData()
      }
    },
    syncTracVidGridData () {
      this.traceVidRowData = this.$refs.traceVidGrid.getAllRows()
    },
    _deleteVid () {
      let selectEqpVo = this.searchTreeNode.detail
      if ((selectEqpVo !== null && selectEqpVo !== undefined) && (this.dcPlanGrid.selectedItems.length > 0)) {
        let checkedRows = this.$refs.traceVidGrid.checkedRows

        if (checkedRows < 1) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
          return
        }

        // TODO :: 같은 vid 모두 check인지 확인
        let allVidCheck = true
        this.traceVidRowData.forEach(row => {
          if (row.vid === checkedRows[0].vid && !row._status.checked) {
            allVidCheck = false
          }
        })

        if (!allVidCheck) {
          this.$dialog.alert(this.$t('fdc.DATA_COLLECTION.MESSAGE.INFORM_NOT_CHECK_VID'))
          return
        }

        checkedRows.some(row => {
          for (let i = this.traceVidRowData.length - 1; i >= 0; i--) {
            if (_.isEqual(this.traceVidRowData[i].vid, row.vid) && _.isEqual(this.traceVidRowData[i].paramName, row.paramName)) {
              this.traceVidRowData.splice(i, 1)
              this.addEqpParamVid(row.vid, row.paramName)
            }
          }
        })

        // [2020.05.28 brique] 수정, save process 변경으로 주석 처리 (grid refresh만 처리) - start
        // this.setVidListToTracePlan()
        this.eqpParamGrid.collectionView.refresh()
        this.traceVidGrid.collectionView.refresh()
        // [2020.05.28 brique] 수정, save process 변경으로 주석 처리 (grid refresh만 처리) - end
      }
    },
    /**
     * Trace Collection Plan에 등록된 VID 삭제 (Vid List에 미표시)
     * @param {*} vid VID
     * @param {*} paramName Parameter Name
     * VID, Parameter Name에 해당하는 Parameter가 Trace Collection Plan에 존재할 경우 Vid List에 표시하지 않습니다.
     */
    delEqpParamVid (vid, paramName) {
      const findItem = this.eqpParamRowData.find(function (item) { return (_.isEqual(item.vid, vid) && _.isEqual(item.paramName, paramName)) })
      if (findItem === null || findItem === undefined) {
        return
      }
      const index = this.eqpParamRowData.indexOf(findItem)
      if (index >= 0) {
        this.eqpParamRowData.splice(index, 1)
      }
    },
    /**
     * VID List 추가 (Vid List에 표시)
     * @param {*} vid VID
     * @param {*} paramName Parameter Name
     */
    addEqpParamVid (vid, paramName) {
      const findItem = this.eqpParamOrgRowData.find(function (item) { return (_.isEqual(item.vid, vid) && _.isEqual(item.paramName, paramName)) })
      if (findItem === null || findItem === undefined) {
        return
      }
      const index = this.eqpParamOrgRowData.indexOf(findItem)
      if (index >= 0) {
        // findItem['_status'].checked = false
        this.eqpParamRowData.splice(this.eqpParamRowData.length, 0, _.clone(findItem))
      }
    },
    /**
     * Vid List 포맷 변경
     * @param {Array} vidList vid 목록 배열
     * @returns {String} vid 목록을 ','로 연결한 값
     * Trace Collection Plan에 저장되는 형태로 Vid List를 변경합니다.
     */
    vidListToString (vidList) {
      if (vidList === null || vidList === undefined || vidList.length <= 0) {
        return null
      }

      let vidString = ''
      let idx = 0
      vidList.some(row => {
        if (idx !== 0) {
          vidString += ','
        }
        vidString += row
        idx = idx + 1
      })
      return vidString
    },
    /**
     * Trace Collection Plan 저장
     */
    async saveTracePlan () {
      const self = this

      let saveRows = []
      const checkedRows = this.$refs.tracePlanGrid.getCheckedRows()
      const selectedVidListRows = this.$refs.traceVidGrid.getAllRows()

      if (checkedRows.length < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
        return
      }

      let idx = 0
      let updateVids = ''
      selectedVidListRows.some(row => {
        const item = _.clone(row)

        if (idx !== 0) {
          updateVids += ','
        }
        updateVids += item.vid
        idx = idx + 1
      })

      let updateVidList = Array.from(new Set(updateVids.split(',')))
      updateVidList.sort()
      updateVids = ''

      updateVids = this.vidListToString(updateVidList)

      let data = {
        fab: checkedRows[0].fab,
        eqpId: checkedRows[0].eqpId,
        planName: checkedRows[0].planName,
        trid: checkedRows[0].trid,
        mainYn: this.detailTridMain,
        runInterval: this.detailRunInterval,
        idleInterval: this.detailIdleInterval,
        vidList: updateVids
      }

      saveRows.push(data)

      // 변경된 데이터가 없다.
      if (saveRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
        return
      }

      let confirmMessage = ''
      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')

      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      if (this.saveValidationCheck(saveRows) === false) {
        return
      }

      let payload = saveRows

      this.$dialog.confirm({
        message: confirmMessage,
        onConfirm: async function () {
          let responseData = await API.FdcCollectionPlan.updateTraceCollectionPlan(payload)
          if (responseData != null && responseData.status === 200) {
            self.$dialog.alert(successMessage)
            // self.tracePlanRowData.forEach(row => {
            //   row['_status'].added = false
            //   row['_status'].checked = false
            //   row['_status'].modified = false
            // })
            self.lastestSelectedData = checkedRows[0]
            self.refreshTracePlanGrid()
          } else {
            self.$dialog.alert(failMessage)
          }
        }
        // onCancel: function () {}
      })
    },
    async _saveTracePlan () {
      const self = this

      let saveRows = []

      if (this.tracePlanGrid.selectedItems.length !== 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
        return
      }

      let idx = 0
      let updateVids = ''
      this.traceVidGrid.rows.some(row => {
        const item = _.clone(row.dataItem)

        if (idx !== 0) {
          updateVids += ','
        }
        updateVids += item.vid
        idx = idx + 1
      })

      let updateVidList = Array.from(new Set(updateVids.split(',')))
      updateVidList.sort()
      updateVids = ''

      updateVids = this.vidListToString(updateVidList)

      let data = {
        fab: this.tracePlanGrid.selectedItems[0].fab,
        eqpId: this.tracePlanGrid.selectedItems[0].eqpId,
        planName: this.tracePlanGrid.selectedItems[0].planName,
        trid: this.tracePlanGrid.selectedItems[0].trid,
        mainYn: this.detailTridMain,
        runInterval: this.detailRunInterval,
        idleInterval: this.detailIdleInterval,
        vidList: updateVids
      }

      saveRows.push(data)

      // 변경된 데이터가 없다.
      if (saveRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
        return
      }

      let confirmMessage = ''
      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')

      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      if (this.saveValidationCheck(saveRows) === false) {
        return
      }

      let payload = saveRows

      this.$dialog.confirm({
        message: confirmMessage,
        onConfirm: async function () {
          let responseData = await API.FdcCollectionPlan.updateTraceCollectionPlan(payload)
          if (responseData != null && responseData.status === 200) {
            self.$dialog.alert(successMessage)
            self.tracePlanRowData.forEach(row => {
              row['_status'].added = false
              row['_status'].checked = false
              row['_status'].modified = false
            })
            self.refreshTracePlanGrid()
          } else {
            self.$dialog.alert(failMessage)
          }
        }
        // onCancel: function () {}
      })

      // [2020.05.28 brique] 수정, save process 변경으로 주석처리
      // const self = this

      // const allRows = this.$refs.tracePlanGrid.rows
      // const checkedRows = this.$refs.tracePlanGrid.checkedRows
      // let saveRows = []

      // if (checkedRows < 1) {
      //   this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
      //   return
      // }

      // allRows.some(row => {
      //   const rowStatus = row.dataItem._status
      //   // 변경되어 선택된 저장 대상
      //   if (rowStatus.checked && (rowStatus.added || rowStatus.modified)) {
      //     const item = _.clone(row.dataItem)
      //     delete item['_status']
      //     saveRows.push(item)
      //   }
      // })

      // // 변경된 데이터가 없다.
      // if (saveRows < 1) {
      //   this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
      //   return
      // }

      // let confirmMessage = ''
      // const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      // const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')

      // confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      // if (this.saveValidationCheck(saveRows) === false) {
      //   return
      // }

      // let payload = saveRows

      // this.$dialog.confirm({
      //   message: confirmMessage,
      //   onConfirm: async function () {
      //     let responseData = await API.FdcCollectionPlan.updateTraceCollectionPlan(payload)
      //     if (responseData != null && responseData.status === 200) {
      //       self.$dialog.alert(successMessage)
      //       self.tracePlanRowData.forEach(row => {
      //         row['_status'].added = false
      //         row['_status'].checked = false
      //         row['_status'].modified = false
      //       })
      //       self.refreshTracePlanGrid()
      //     } else {
      //       self.$dialog.alert(failMessage)
      //     }
      //   }
      //   // onCancel: function () {}
      // })
    },
    /**
     * Trace Collection Plan Save Validation
     * @param {Array} rows grid row 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidationCheck (rows) {
      // todo : min, max value 설정
      // run interval 10 ~ 99999999까지...
      // max length
      for (let i in rows) {
        if (!rows[i].fab || rows[i].fab.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['FAB']))
          return false
        } else if (!rows[i].eqpId || rows[i].eqpId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['EQP ID']))
          return false
        } else if (!rows[i].planName || rows[i].planName.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['PLAN NAME']))
          return false
        } else if (!rows[i].trid || rows[i].trid.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['TRID']))
          return false
        }
      }
      return true
    },
    /**
     * Trace Collection Plan 삭제
     */
    async deleteTracePlan () {
      const that = this
      const checkedRows = this.$refs.tracePlanGrid.getCheckedRows()
      let deleteRow = []

      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        if (rowStatus !== 'C') {
          deleteRow.push(row)
        }
      })

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
      }

      const confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE', [checkedRows.length])
      const completeMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')

      let payload = deleteRow

      this.$dialog.confirm({
        message: confirmMessage,
        onConfirm: async function () {
          if (deleteRow.length > 0) {
            await API.FdcCollectionPlan.deleteTraceCollectionPlan(payload)
          }
          that.$dialog.alert(completeMessage)
          that.refreshTracePlanGrid()
        }
      })
    }
  },
  data () {
    return {
      lastestSelectedData: null,
      dcColumns: [], // Data Collection Plan grid column 배열
      tracePlanColumns: [], // Trace Collection Plan grid column 배열
      eqpParamColumns: [], // Parameter grid colum 배열 (vid list)
      traceVidColumns: [], // Selected Vid List grid colum 배열
      dcRowData: [], // Data Collection Plan row data
      dcSelRowIdx: -1, // Data Collection Plan select row index
      tracePlanRowData: [], // Trace Collection Plan row data
      tracePlanOrgRowData: [], // Trace Collection Plan row data (수정 전)
      traceSelRowIdx: -1, // Trace Collection Plan select row index
      eqpParamRowData: [], // Parameter row data
      eqpParamOrgRowData: [], // Parameter row data (수정 전)
      traceVidRowData: [], // Selected Vid List row data
      traceVidOrgRowData: [], // Selected Vid List row data (수정 전)
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색한 EQP Tree node
      tracePlanCollectionViewOptions: {
        sortDescriptions: ['trid']
      }, // Trace Collection Plan grid collectionView Option
      vidCollectionViewOptions: {
        sortDescriptions: ['vid']
      }, // Parameter/Selected Vid List grid collectionView Option
      nodeObj: null, // Data Collection Plan에서 화면 연동시 저장된 EQP Tree node 정보
      detailTrid: null, // 선택된 Trace Collection Plan TRID data
      detailTridMain: null, // 선택된 Trace Collection Plan TRID Main data
      detailRunInterval: null, // 선택된 Trace Collection Plan Run Interval data
      detailIdleInterval: null, // 선택된 Trace Collection Plan Idel Interval data
      enableEditTracePlan: false, // Trace Collection Plan 저장 가능 여부
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }
    }
  }
}
